<template>
  <v-container>
    <v-layout row wrap>
      <v-flex sm4>
        <v-flex
          class="text-xs-center text-sm-center text-md-center text-lg-center"
        >
          <img
            :src="bankStatementFirstPageUrl"
            height="150"
            v-if="bankStatementFirstPageUrl"
          />
          <v-text-field
            label="Select Bank Statement First Page"
            @click="pickBankStatementFirstPage"
            v-model="bankStatementFirstPage"
            prepend-icon="attach_file"
          ></v-text-field>
          <input
            type="file"
            style="display: none"
            ref="bankStatementFirstPage"
            accept="image/*"
            @change="onBankStatementFirstPagePicked"
          />
        </v-flex>
        <v-flex
          class="text-xs-center text-sm-center text-md-center text-lg-center"
        >
          <img
            :src="bankStatementLastPageUrl"
            height="150"
            v-if="bankStatementLastPageUrl"
          />
          <v-text-field
            label="Select Bank Statement Last Page"
            @click="pickBankStatementLastPage"
            v-model="bankStatementLastPage"
            prepend-icon="attach_file"
          ></v-text-field>
          <input
            type="file"
            style="display: none"
            ref="bankStatementLastPage"
            accept="image/*"
            @change="onBankStatementLastPagePicked"
          />
        </v-flex>
        <v-btn
          :disabled="!bankStatementFirstPage || !bankStatementLastPage"
          :loading="loading"
          @click="onSubmit"
          color="success"
        >
          Submit
        </v-btn>
      </v-flex>
      <v-flex sm1></v-flex>
      <v-flex sm7 v-if="responseReceived">
        <v-tabs>
          <v-tab ripple>Raw Data</v-tab>
          <v-tab ripple>Extracted Data</v-tab>
          <br />
          <v-tab-item>
            <json-viewer
              :value="bankStatementData"
              :expand-depth="1"
              copyable
              sort
            ></json-viewer>
          </v-tab-item>
          <v-tab-item>
            <FundingDetailsBankStatementData
              :bankStatementData="bankStatementData"
            />
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import JsonViewer from "vue-json-viewer";
  import FundingDetailsBankStatementData from "@/components/FundingDetailsBankStatementData";
  import axios from "axios";
  export default {
    components: {
      JsonViewer,
      FundingDetailsBankStatementData,
    },
    data: () => ({
      title: "Bank Statement Upload",
      loading: false,
      bankStatementFirstPage: "",
      bankStatementFirstPageUrl: "",
      bankStatementFirstPageFile: "",
      bankStatementLastPage: "",
      bankStatementLastPageUrl: "",
      bankStatementLastPageFile: "",
      bankStatementData: null,
      responseReceived: false,
    }),

    methods: {
      pickBankStatementFirstPage() {
        this.$refs.bankStatementFirstPage.click();
      },

      onBankStatementFirstPagePicked(e) {
        const files = e.target.files;
        if (files[0] !== undefined) {
          this.bankStatementFirstPage = files[0].name;
          if (this.bankStatementFirstPage.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.bankStatementFirstPageUrl = fr.result;
            this.bankStatementFirstPageFile = files[0]; // this is an image file that can be sent to server...
          });
        } else {
          this.bankStatementFirstPage = "";
          this.bankStatementFirstPageFile = "";
          this.bankStatementFirstPageUrl = "";
        }
      },

      pickBankStatementLastPage() {
        this.$refs.bankStatementLastPage.click();
      },

      onBankStatementLastPagePicked(e) {
        const files = e.target.files;
        if (files[0] !== undefined) {
          this.bankStatementLastPage = files[0].name;
          if (this.bankStatementLastPage.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.bankStatementLastPageUrl = fr.result;
            this.bankStatementLastPageFile = files[0]; // this is an image file that can be sent to server...
          });
        } else {
          this.bankStatementLastPage = "";
          this.bankStatementLastPageFile = "";
          this.bankStatementLastPageUrl = "";
        }
      },

      async onSubmit() {
        try {
          this.loading = true;
          this.responseReceived = false;
          let formData = new FormData();
          formData.append("bank_statement", this.bankStatementFirstPageFile);
          let data = new FormData();
          data.append(
            "first_page",
            this.bankStatementFirstPageFile,
            this.bankStatementFirstPageFile.name
          );
          data.append(
            "last_page",
            this.bankStatementLastPageFile,
            this.bankStatementLastPageFile.name
          );

          const response = await axios.post(
            "http://bsv.shadhinbd.com/2.1/bank-statement/extract",
            data,
            {
              headers: {
                accept: "application/json",
                "Accept-Language": "en-US,en;q=0.8",
                "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
              },
            }
          );
          this.bankStatementData = response.data;
          this.responseReceived = true;
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
